//src/app/features/taxEstimates/CreateTaxEstimate.tsx
import { DashboardContainerHeader } from 'app/layout/dashboardLayout/BoxLayout';
import { useCreateTaxEstimateMutation } from 'app/services/taxEstimates';
import { SaveIcon } from 'assets/icons';
import Button from 'Components/Buttons/Button';
import { successToast } from 'Components/Notifications';
import { useAuth } from 'utils/AuthProvider';
import TaxEstimateForm from './TaxEstimateForm';
import { useNavigate } from 'react-router-dom';

export default function CreateTaxEstimate() {
  const [CreateTrigger, { isLoading }] = useCreateTaxEstimateMutation();
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <>
      <DashboardContainerHeader title={'Tax Fee Estimation Request'}>
        <Button
          isLoading={isLoading}
          form="tax-estimate-form"
          className="max-w-min"
        >
          <SaveIcon className="w-4 h-4" />
          Create
        </Button>
      </DashboardContainerHeader>
      <TaxEstimateForm
        value={{
          firstName: user?.given_name,
          lastName: user?.family_name,
          email: user?.email,
          ssn: user?.ssn,
          haveDependents: !!user?.dependents ? 'yes' : 'no',
          isMarried: !!user?.spouse ? 'yes' : 'no',
          spouseFirstName: user?.spouse?.firstname,
          spouseLastName: user?.spouse?.lastname,
          spouseSSN: user?.spouse?.ssn,
          phoneNumber: user?.phone_number,
          reachPhoneNumber: user?.phone_number,
          address: user?.address,
          city: user?.city,
          state: user?.state,
          zipCode: user?.zipcode,
        }}
        onChange={(data) => {
          console.log(data);

          return CreateTrigger(data)
            .unwrap()
            .then(() => {
              successToast('Tax estiamate request submitted');
              navigate('..');
            });
        }}
        isLoading={isLoading}
      />
    </>
  );
}
